import React, { JSX } from "react";
import { Client } from "generated/graphql";
import { EditClientForm } from "components/editVersioned/editClient";
import {} from "queries/newProject";
import { ManageGeneric } from "./common";

export const ManageClients = (): JSX.Element => {
  return (
    <ManageGeneric<Client>
      title="Kunden"
      searchType="new_client"
      dataAccessor="newClient"
      editForm={EditClientForm}
      listItemContent={(client) => <>{client.name}</>}
    />
  );
};
